import {ActionReducerMap} from '@ngrx/store';
import * as storeKeys from './../store-key.config';
import {authReducer} from './auth.reducer';
import {categoriesReducer} from './categories.reducer';
import {rolesReducer} from './roles.reducer';
import {addUserSettingsReducer} from './user_settings.reducer';

/**
 * multiple reducer
 */
export const reducers: ActionReducerMap<AppState> = {
    [storeKeys.user_settings_key]: addUserSettingsReducer,
    [storeKeys.roles_key]: rolesReducer,
    [storeKeys.auth_key]: authReducer,
    [storeKeys.categories]: categoriesReducer
};


export interface AppState{
}
